import React, { createContext, useContext, useState } from 'react';

interface ContactosDistribuidorDestino {
    clienteId: number;
    clienteDistribuidorId: number;
    contactos: any[]
}

interface ContactosDistribuidorDestinoContextProps {
    contactosDistribuidorDestino: ContactosDistribuidorDestino;
    setContactosDistribuidorDestino: React.Dispatch<React.SetStateAction<ContactosDistribuidorDestino>>;
}


const ContactosDistribuidorDestinoContext = createContext<ContactosDistribuidorDestinoContextProps | undefined>(undefined);

export const ContactosDistribuidorDestinoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [contactosDistribuidorDestino, setContactosDistribuidorDestino] = useState<ContactosDistribuidorDestino>({ clienteId: 0, clienteDistribuidorId: 0 , contactos: [] });

    return (
        <ContactosDistribuidorDestinoContext.Provider value={{ contactosDistribuidorDestino, setContactosDistribuidorDestino }}>
            {children}
        </ContactosDistribuidorDestinoContext.Provider>
    );
};

// Hook
export const useContactosDistribuidorDestino = () => {
    const context = useContext(ContactosDistribuidorDestinoContext);
    if (!context) {
        throw new Error("useContactosDistribuidorDestino debe ser usado dentro de un ContactosDistribuidorDestinoProvider");
    }
    return context;
};
